import React, { useCallback } from 'react';
import { mergeStyles } from '@cian/utils';

import { EPageKind } from '../../../../types/page';
import { ICard } from '../../GlamorousCards/types';
import { Card } from '../../Card';
import { Text } from '../../Text';
import { Button } from '../../Button';
import { trackCardClick } from '../../tracking/trackCardClick';

import styles from './HorizontalHalfImageCard.css';

interface IProps extends ICard {
  pageKind: EPageKind;
  className?: string;
}

export const HorizontalHalfImageCard = (props: IProps) => {
  const { pageKind, title, description, imageUrl, link, buttonText, className } = props;

  const { className: rootClassName } = mergeStyles(styles['card'], className);
  const trackClick = useCallback(() => trackCardClick({ pageKind, cardTitle: title }), []);

  const imageStyle = {
    backgroundImage: `url(${imageUrl})`,
  };

  return (
    <Card link={link} className={rootClassName} onClick={trackClick}>
      <div style={imageStyle} className={styles['image']} />

      <div className={styles['content']}>
        <Text type="h4" lineClamp={2} className={styles['title']}>
          {title}
        </Text>
        <Text lineClamp={3} className={styles['description']}>
          {description}
        </Text>

        <Button className={styles['button']}>{buttonText || 'Интересно'}</Button>
      </div>
    </Card>
  );
};
